import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";
import { styles } from "./constants/styles";
import ChangePasswordPage from "./ChangePasswordPage/ChangePasswordPage";
import SuccessPasswordChangePage from "./SuccessPasswordChangePage/SuccessPasswordChangePage";
type Props = WithStyles<typeof styles>;

const ExpiredPasswordPage: React.FC<Props> = (props: Props) => {
  const [successChange, setSuccessChange] = React.useState(false)

    
      
  return (
    <>
    <Layout>
      <Header />
      {!successChange  ? <ChangePasswordPage submit={setSuccessChange}/> : <SuccessPasswordChangePage/>}
      <Footer />
    </Layout>
    </>
  );
};

export default withStyles(styles)(ExpiredPasswordPage);
